import { h, Component } from 'preact';
import cn from 'classnames';
import Icon from '../icon/icon';
import styles from './inlineMessage.css';

const glyphs = {
  error: 'exclamation',
  info: 'info',
  success: 'tick',
};

export default class InlineMessage extends Component {
  static defaultProps = {
    type: 'info'
  }

  render() {
    const { children, type } = this.props;
    return (<div className={cn('flex', styles.container, styles[type])}>
      <Icon glyph={glyphs[type]} className={styles.icon} />
      <span className={cn(styles.message, 'flex-grow')}>{children}</span>
    </div>);
  }
}



// WEBPACK FOOTER //
// ./components/inlineMessage/inlineMessage.jsx